// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"4090f0f3","150":"887e8fd5","239":"11d7ab8b","453":"6e0a3624","560":"a7b1b768","968":"2eef38be","987":"ee08edd7"}[chunkId] + ".chunk.js";
};